import { formatCurrency } from '@hotel/shared/utils'
import type { PublicPricing } from '../api/types'

export function TaxNote({ pricing }: { pricing: PublicPricing }) {
  const names = pricing.tax_breakdown.map((tax) => tax.tax_name).join(', ')
  return <small className="tax-note">Impuestos incluidos{names ? ` (${names})` : ''}</small>
}

export function PriceBreakdown({ pricing }: { pricing: PublicPricing }) {
  return (
    <div className="price-breakdown">
      <div className="summary-row"><span>Hospedaje sin impuestos</span><strong>{formatCurrency(pricing.base_total)}</strong></div>
      {pricing.tax_breakdown.map((tax) => (
        <div className="summary-row" key={tax.tax_id}>
          <span>{tax.tax_name} ({tax.rate}%)</span><strong>{formatCurrency(tax.amount)}</strong>
        </div>
      ))}
      <div className="summary-row total"><span>Total de estadía</span><strong>{formatCurrency(pricing.total)}</strong></div>
      <TaxNote pricing={pricing} />
    </div>
  )
}
